import { createInitialSave, parseSaveGame, type SaveGame } from "./schema";

export const SAVE_KEY = "lilys-adventure:save:v7";
export const LEGACY_V6_SAVE_KEY = "lilys-adventure:save:v6";
export const LEGACY_V5_SAVE_KEY = "lilys-adventure:save:v5";
export const LEGACY_V4_SAVE_KEY = "lilys-adventure:save:v4";
export const LEGACY_V3_SAVE_KEY = "lilys-adventure:save:v3";
export const LEGACY_V2_SAVE_KEY = "lilys-adventure:save:v2";
export const LEGACY_SAVE_KEY = "lilys-adventure:save:v1";

export interface SaveLoadResult {
  save: SaveGame;
  recovered: boolean;
  migrated: boolean;
}

type ReadStorage = Pick<Storage, "getItem">;
type WriteStorage = Pick<Storage, "setItem" | "removeItem">;
const LEGACY_KEYS = [
  LEGACY_V6_SAVE_KEY,
  LEGACY_V5_SAVE_KEY,
  LEGACY_V4_SAVE_KEY,
  LEGACY_V3_SAVE_KEY,
  LEGACY_V2_SAVE_KEY,
  LEGACY_SAVE_KEY,
];

export function loadSave(storage: ReadStorage): SaveLoadResult {
  const current = storage.getItem(SAVE_KEY);
  if (current) {
    const save = parseSaveGame(current);
    return save
      ? { save, recovered: false, migrated: false }
      : { save: createInitialSave(), recovered: true, migrated: false };
  }

  for (const legacyKey of LEGACY_KEYS) {
    const serialized = storage.getItem(legacyKey);
    if (!serialized) continue;
    const migrated = parseSaveGame(serialized);
    return migrated
      ? { save: migrated, recovered: false, migrated: true }
      : { save: createInitialSave(), recovered: true, migrated: false };
  }
  return { save: createInitialSave(), recovered: false, migrated: false };
}

export function storeSave(storage: WriteStorage, save: SaveGame): void {
  storage.setItem(SAVE_KEY, JSON.stringify(save));
  for (const legacyKey of LEGACY_KEYS) storage.removeItem(legacyKey);
}

export function resetSave(storage: WriteStorage): SaveGame {
  storage.removeItem(SAVE_KEY);
  for (const legacyKey of LEGACY_KEYS) storage.removeItem(legacyKey);
  return createInitialSave();
}
